import { AlertBanner, Code, Stack, Text } from '@engram/ui-components';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { resolveEnvironment } from './config';
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Fail closed on an unrecognised hostname, such as the Static Web App's own
// *.azurestaticapps.net name. Bail before the MSAL graph is imported, so no
// Entra client is constructed and no token is requested.
if (resolveEnvironment() === null) {
  createRoot(rootElement).render(
    <StrictMode>
      <div className="p-12">
        <Stack gap="4" align="center">
          <AlertBanner variant="critical" title="This address is not recognised">
            <Stack gap="2">
              <Text>
                The backoffice will not sign you in from an address it does not recognise. Open it
                from its official address.
              </Text>
              <Text variant="body-sm">
                Address: <Code>{window.location.hostname}</Code>
              </Text>
            </Stack>
          </AlertBanner>
        </Stack>
      </div>
    </StrictMode>,
  );
} else {
  const { mountApp } = await import('./mountApp');
  await mountApp(rootElement);
}
